export enum ActionEventHandler {
  VIEW = "VIEW",
  DELETE = "DELETE",
  ADD = "ADD",
  NOCHANGE = "NOCHANGE",
  EDIT = "EDIT",
  COPY = "COPY",
  RELOAD = "RELOAD",
  PENDING = "PENDING",
  INPROGRESS = "INPROGRESS",
  APPROVE = "APPROVE",
  PAID = "PAID",
  REJECT = "REJECT",
  CLOSED = "CLOSED",
  OPEN = "OPEN",
  VIEWDETAIL = "VIEWDETAIL",
  ROWCLICKED = "ROWCLICKED",
  CANCEL = "CANCEL",
  COMPLETE = "COMPLETE",
  RESCHEDULE = "RESCHEDULE",
  SCHEDULE_CALL = "SCHEDULE_CALL",
  MAKE_APPOINTMENT = "MAKE_APPOINTMENT",
  SHARE = "SHARE",
  DOWNLOAD = "DOWNLOAD",
  BOOKMARK = "BOOKMARK",
  DONE = "DONE",
  REQUEST_QUOTATION = "REQUEST_QUOTATION",
  MESSAGE = "MESSAGE",
  EMAIL = "EMAIL",
  VIEW_RATINGS = "VIEW_RATINGS",
  SENT = "SENT",
  ASSIGN_JOB = "ASSIGN_JOB",
  GEN_INVOICE = "GEN_INVOICE",
  UPLOAD = "UPLOAD",
  ACCEPT = "ACCEPT",
  PAY = "PAY",
  REPORT = "REPORT"
}
